import { Getters } from 'vuex-smart-module';
import ModelAccreditationState from './state';

export default class ModelAccreditationGetters extends Getters<ModelAccreditationState> {}
